import { render } from "./SectionRenderer.vue?vue&type=template&id=42c926bd"
import script from "./SectionRenderer.vue?vue&type=script&lang=js"
export * from "./SectionRenderer.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__